function smoothScroll() {
  const OFFSET = 123;

  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    const target = $(this.hash);
    if (target.length) {
      const targetOffset = target.offset().top - OFFSET;

      $('html, body').animate({
        scrollTop: targetOffset
      }, 800);
    }
  });

  // Rev Slider scroll button
  $('.rev-btn-scroll, .btn-scroll').on('click', function () {
    const button = $(this);
    if (button.length) {
      const buttonBottom = button.offset().top + button.outerHeight();
      $('html, body').animate({
        scrollTop: buttonBottom
      }, 800);
    }
  });

  // Scroll to top functionality for icon-arrow-circled
  $('.scroll-to-top').parent('a').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 800);
  });
}

export default smoothScroll;